<template>
    <div style="width:100%;">

        <div class="cart_list_row"
             v-for="(item, index) in cart.items"
             :key="index"
             :class="{ disabled: item.invalid }">


            <!-- first row for qty, item name, price -->
            <div class="cart_item_info_row" :class="{isUpdate : can_update, issoldout : item.invalid}">

                <div class="item_qty_div">
                    <div class="item_qty_select_div">
                        <select class="item_qty_select" @change="$root.setCartItemSelectQty(item,$event)" v-if="can_update">
                            <option class=""
                                    v-for="(i, index) in CheckItemOptionMaxQty(item)"
                                    :key="'iq'+index"
                                    :value="i"
                                    :selected="i == item.qty">
                                {{ CheckItemOptionDisplay(i) }}
                            </option>
                        </select>
                        <div class="item_qty_select_display" v-if="!can_update">{{ item.qty }}</div>
                    </div>
                </div>
                <div class="item_name_div">
                    <div class="item_name">
                        <div class="item_name_text">{{item['name'+getItemSubfix()]}}</div>
                    </div>
                </div>
                <div class="item_price_div">
                    <div class="item_price">
                        <money :price="item.discountPrice * item.qty" />
                    </div>
                </div>

            </div>

            <!-- second row for options -->
            <div class="cart_item_info_row" :class="{isUpdate : can_update, issoldout : item.invalid}">

                <div class="item_qty_div">                   
                </div>
                <div class="item_name_div with_price">

                    <div class="item_option">

                        <div class="option_list_row"
                             v-for="(opt,index_opt) in item.options">

                            <div class="option_list_div" v-if="opt.items.length > 0">
                                <div class="option_type">
                                    {{opt['name'+getItemSubfix()]}}<span class="sub_amount" v-if="opt['price'] != null && opt['price'] > 0">(<money :price="opt['price']" />)</span>
                                </div>

                                <div class="option_sublist_div"
                                     v-for="(opt_item, index_item) in opt.items">
                                    <div class="option_type">
                                        <div class="option_type_qty">
                                            {{opt_item['qty']}}X
                                        </div>
                                        <div class="option_type_name">
                                            {{opt_item['name'+getItemSubfix()]}}<span class="sub_amount" v-if="opt_item['price'] != null && opt_item['price'] > 0">(<money :price="opt_item['price']" />)</span>
                                        </div>
                                    </div>

                                    <div class="option_modifier"
                                         v-for="(mg, index_mg) in opt_item.modifierGroup">
                                        <!--<div class="option_type">
                                            {{mg['name'+getItemSubfix()]}}<span class="sub_amount" v-if="mg['price'] != null && mg['price'] > 0">(<money :price="mg['price']" />)</span>
                                        </div>-->
                                        <div class="option_name"
                                             v-for="(mi, index_mi) in mg.modifiers">
                                            <!--{{mi['qty']}}X--> {{mi['name'+getItemSubfix()]}}<span class="sub_amount" v-if="mi['price'] != null && mi['price'] > 0">(<money :price="mi['price']" />)</span>
                                        </div>
                                    </div>
                                    <!-- option_list_row for option item modifier end  -->
                                </div>
                                <!-- option_list_row for option item end  -->
                            </div>

                        </div>
                        <!-- option_list_row for option end  -->

                        <div class="option_list_row nomargin"
                             v-for="(mg, index_mg) in item.modifierGroup" 
                             v-if="item.modifierGroup.length > 0"
                             :class="{nomargin : index_mg == item.modifierGroup.length - 1}">

                            <div class="option_list_div" v-if="index_mg == 0">
                                <div class="option_type">
                                    <div class="option_type_name full">
                                        {{label['cart_Item_Modifier_Label_text']}}
                                    </div>
                                </div>
                            </div>

                            <div class="option_list_div" v-if="mg.modifiers.length > 0">
                                <!--<div class="option_type">
                                    {{mg['name'+getItemSubfix()]}}<span class="sub_amount" v-if="mg['price'] != null && mg['price'] > 0">(<money :price="mg['price']" />)</span>
                                </div>-->
                                <div class="option_name"
                                     v-for="(mi, index_mi) in mg.modifiers">
                                    <!--{{mi['qty']}}X--> {{mi['name'+getItemSubfix()]}}<span class="sub_amount" v-if="mi['price'] != null && mi['price'] > 0">(<money :price="mi['price']" />)</span>
                                </div>
                            </div>

                        </div>
                        <!-- option_list_row for modifier end  -->
                    </div>

                </div>

            </div>
            <!-- cart_item_info_row -->

            <!-- third row for soldout -->
            <div class="cart_item_info_row" :class="{isUpdate : can_update}" v-if="item.invalid">
                <div class="item_qty_div"></div>
                <div class="item_name_div with_price soldout_text">
                    <div class="item_name">
                        <div class="item_name_text">{{label["menu_soldout_text"]}}</div>
                    </div>
                </div>
            </div>

        </div>
        <!-- cart_list_row -->

    </div>
</template>

<script>
export default {
        props: {
            cart: Object,
            can_update: Boolean,
        },
  data() {
    return {};
  },
  computed: {
    info() {
        return this.$root.info;
    },
    label() {
        return this.$root.getLabel();
    },
    /*cart() {
        return this.$root.cart;
    },*/    
  },
  created() {
  },
  methods:{
    getItemSubfix() {
      return this.$root.getItemSubfix();
    },
    CheckItemOptionDisplay(i) {
        return i+'' == '0' ? 'X' : i+'';
    },
    CheckItemOptionMaxQty(item) {
        if (item.maxQty <= -1) {
            return this.$root.cart_item_qty_arr_0;
        }
        else {
            if (item.maxQty >= this.$root.cart_item_qty_arr_0[this.$root.cart_item_qty_arr_0.length - 1]) {
                return this.$root.cart_item_qty_arr_0;
            }
            else {
                var new_arr = []; 
                for (var i = 0; i <= item.maxQty; i++) {
                    new_arr.push(i);
                }
                return new_arr;
            }
        }
    }
  }
};
</script>